const downloadFile = (blob, fileName) => {
  const anchor = document.createElement('a');
  const url = window.URL.createObjectURL(blob);

  anchor.style.display = 'none';
  document.body.appendChild(anchor);

  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  window.URL.revokeObjectURL(url);
};

export default downloadFile;



// WEBPACK FOOTER //
// ../utils/functions/download-file.js